import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';
import Logo from './Logo';

const NAV = [
  { to: '/#tipsters', label: 'Tipsters', id: 'tipsters' },
  { to: '/results', label: 'Results', id: 'results' },
  { to: '/#pricing', label: 'Pricing', id: 'pricing' },
  { to: '/about', label: 'About', id: 'about' },
  { to: '/contact', label: 'Contact', id: 'contact' }
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-line" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-[76px] flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map(n => (
            <Link
              key={n.id}
              to={n.to}
              data-testid={`nav-${n.id}`}
              className={`px-4 py-2 rounded-full text-[13.5px] font-semibold transition-colors ${
                pathname === n.to ? 'text-royal bg-ice' : 'text-slate-600 hover:text-navy hover:bg-mist'
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/subscribe" className="btn-primary !h-11 !px-5 text-sm" data-testid="nav-cta-button">
            Subscribe <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <button className="lg:hidden p-2 rounded-lg hover:bg-mist" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-line bg-white" data-testid="nav-mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV.map(n => (
              <Link key={n.id} to={n.to} onClick={() => setOpen(false)} className="px-3 py-3 rounded-lg text-navy font-semibold hover:bg-mist">
                {n.label}
              </Link>
            ))}
            <Link to="/subscribe" onClick={() => setOpen(false)} className="btn-primary mt-3">
              Subscribe <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
